import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  warning:
    'Payments have been deactivated for this account. For more information, please contact Zeller support.',
})
